import _ from 'lodash';
import React from 'react';
import { History } from 'history';
import { truncateLongText } from 'o2o_layout';
import { User } from 'o2o_layout/lib/common/model';
import { Row, Col, Avatar, Icon, Button, Tooltip, Dropdown, Menu } from 'antd';

import { Link } from 'react-router-dom';
import { IState } from '../../../../redux/reducer';
import { useSelector } from '../../../../redux/store';
import { getPrimaryColor } from '../../../../common/helper';
import { DashboardProps } from '../ModernLayoutContainer';

interface IAvatarMenuProps extends DashboardProps {
  user: User | undefined;
  accountUrl: string;
  appUrl: string;
  overrideSignOut?: React.ReactNode | undefined;
  urlSelectCompnany?: React.ReactNode | undefined;
  urlSelectProfile?: React.ReactNode | undefined;
  userLogout?: any;
  userLogoutAll?: any;
  setGlobalLoading?: any;
  history: History;
}

const AccountDropDown = (props: IAvatarMenuProps) => {
  const { uiSetting } = useSelector((state: IState) => state);

  const primaryColor = getPrimaryColor(uiSetting);

  return (
    <Row
      id='dropdown-account-profile-warpper'
      type='flex'
      gutter={[5, 5]}
      justify='start'
      style={{
        maxWidth: 250,
        minWidth: 250,
        padding: '10px 15px 10px 15px',
      }}
    >
      <Col span={24}>
        <Row type='flex' gutter={[15, 8]} justify='center' align='middle'>
          <Col>
            <Avatar
              style={{
                border: `2px solid ${primaryColor}`,
              }}
              src={props.user ? props.user.avatar : undefined}
              icon='user'
              size={85}
            ></Avatar>
            {props.user && props.user.totpEnabled ? (
              <span className='shield-avatar2'>
                <Icon
                  component={() => {
                    return (
                      <svg width='1em' height='1em' viewBox='0 0 26 29' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M2.46141 5.76739C2 6.42478 2 8.37887 2 12.287V14.2117C2 21.1026 7.18095 24.4467 10.4316 25.8667C11.3133 26.2519 11.7542 26.4444 13 26.4444C14.2458 26.4444 14.6866 26.2519 15.5684 25.8667C18.819 24.4467 24 21.1026 24 14.2117V12.287C24 8.37887 24 6.42478 23.5386 5.76739C23.0772 5.10999 21.2398 4.48106 17.5651 3.22319L16.865 2.98354C14.9495 2.32785 13.9917 2 13 2C12.0083 2 11.0505 2.32785 9.135 2.98354L8.43489 3.22319C4.76017 4.48106 2.92282 5.10999 2.46141 5.76739ZM16.7393 12.3883C17.0765 12.0107 17.0437 11.4312 16.6661 11.094C16.2884 10.7568 15.709 10.7896 15.3718 11.1673L11.6905 15.2903L10.6282 14.1006C10.291 13.723 9.71157 13.6902 9.33393 14.0273C8.95629 14.3645 8.92349 14.944 9.26067 15.3216L11.0067 17.2772C11.1806 17.472 11.4293 17.5833 11.6905 17.5833C11.9516 17.5833 12.2003 17.472 12.3743 17.2772L16.7393 12.3883Z'
                          fill='currentColor'
                        ></path>
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M10.2861 13.8603C9.97313 13.7349 9.60249 13.7875 9.33393 14.0273C8.95629 14.3645 8.92349 14.944 9.26067 15.3216L11.0067 17.2772C11.1806 17.472 11.4293 17.5833 11.6905 17.5833C11.9516 17.5833 12.2003 17.472 12.3743 17.2772L16.7393 12.3883C17.0765 12.0107 17.0437 11.4312 16.6661 11.094C16.2884 10.7568 15.709 10.7896 15.3718 11.1673L11.6905 15.2903L10.6282 14.1006C10.5308 13.9915 10.4132 13.9112 10.2861 13.8603ZM0.230789 6.13539C0.314425 5.70138 0.467303 5.12716 0.824385 4.61841C1.18723 4.10144 1.684 3.76307 2.06826 3.53991C2.48117 3.30011 2.96802 3.07975 3.49041 2.86753C4.51901 2.44966 5.93966 1.96338 7.72136 1.35351L8.48728 1.09133C8.57688 1.06066 8.66529 1.03033 8.75261 1.00038C10.4093 0.432046 11.6687 0 13 0C14.3313 0 15.5907 0.432046 17.2474 1.00038C17.3347 1.03033 17.4231 1.06066 17.5127 1.09133L18.2787 1.35352C20.0604 1.96339 21.481 2.44967 22.5096 2.86753C23.032 3.07975 23.5188 3.30011 23.9317 3.53991C24.316 3.76307 24.8128 4.10144 25.1756 4.61841C25.5327 5.12716 25.6856 5.70138 25.7692 6.13539C25.8592 6.60236 25.9086 7.13406 25.9394 7.69943C26 8.81327 26 10.3225 26 12.2194V14.2117C26 22.3372 19.8349 26.1855 16.369 27.6994C16.3508 27.7074 16.3325 27.7154 16.314 27.7235C15.9143 27.8983 15.452 28.1005 14.9167 28.2375C14.328 28.3882 13.7286 28.4444 13 28.4444C12.2714 28.4444 11.672 28.3882 11.0833 28.2375C10.548 28.1005 10.0857 27.8983 9.68597 27.7235C9.66751 27.7154 9.64917 27.7074 9.63097 27.6994C6.16513 26.1855 2.03495e-07 22.3372 2.03495e-07 14.2117V12.2193C-8.37957e-06 10.3225 -1.52923e-05 8.81326 0.0606346 7.69943C0.0914199 7.13406 0.1408 6.60236 0.230789 6.13539ZM2 12.287C2 8.37887 2 6.42478 2.46141 5.76739C2.92282 5.10999 4.76017 4.48106 8.43489 3.22319L9.135 2.98354C11.0505 2.32785 12.0083 2 13 2C13.9917 2 14.9495 2.32785 16.865 2.98354L17.5651 3.22319C21.2398 4.48106 23.0772 5.10999 23.5386 5.76739C24 6.42478 24 8.37887 24 12.287V14.2117C24 21.1026 18.819 24.4467 15.5684 25.8667C14.6866 26.2519 14.2458 26.4444 13 26.4444C11.7542 26.4444 11.3133 26.2519 10.4316 25.8667C7.18095 24.4467 2 21.1026 2 14.2117V12.287Z'
                          fill='white'
                        ></path>
                      </svg>
                    );
                  }}
                />
              </span>
            ) : (
              <span className='shield-avatar2'>
                <Icon
                  component={() => {
                    return (
                      <svg width='1em' height='1em' viewBox='0 0 26 29' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <g clip-path='url(#clip0_128_1768)'>
                          <path
                            d='M14 18C14 18.5523 13.5523 19 13 19C12.4477 19 12 18.5523 12 18C12 17.4477 12.4477 17 13 17C13.5523 17 14 17.4477 14 18Z'
                            fill='white'
                          />
                          <path
                            fill-rule='evenodd'
                            clip-rule='evenodd'
                            d='M2 12.287C2 8.37887 2 6.42478 2.46141 5.76739C2.92282 5.10999 4.76017 4.48106 8.43489 3.22319L9.135 2.98354C11.0505 2.32785 12.0083 2 13 2C13.9917 2 14.9495 2.32785 16.865 2.98354L17.5651 3.22319C21.2398 4.48106 23.0772 5.10999 23.5386 5.76739C24 6.42478 24 8.37887 24 12.287V14.2117C24 21.1026 18.819 24.4467 15.5684 25.8667C14.6866 26.2519 14.2458 26.4444 13 26.4444C11.7542 26.4444 11.3133 26.2519 10.4316 25.8667C7.18095 24.4467 2 21.1026 2 14.2117V12.287ZM13 8.41667C13.5063 8.41667 13.9167 8.82707 13.9167 9.33333V14.2222C13.9167 14.7285 13.5063 15.1389 13 15.1389C12.4937 15.1389 12.0833 14.7285 12.0833 14.2222V9.33333C12.0833 8.82707 12.4937 8.41667 13 8.41667ZM13 19.1111C13.675 19.1111 14.2222 18.5639 14.2222 17.8889C14.2222 17.2139 13.675 16.6667 13 16.6667C12.325 16.6667 11.7778 17.2139 11.7778 17.8889C11.7778 18.5639 12.325 19.1111 13 19.1111Z'
                            fill='currentColor'
                          />
                          <path
                            fill-rule='evenodd'
                            clip-rule='evenodd'
                            d='M0.230789 6.13539C0.314425 5.70138 0.467303 5.12716 0.824385 4.61841C1.18723 4.10144 1.684 3.76307 2.06826 3.53991C2.48117 3.30011 2.96802 3.07975 3.49041 2.86753C4.51901 2.44966 5.93966 1.96338 7.72136 1.35351L8.48728 1.09133C8.57688 1.06066 8.66529 1.03033 8.75261 1.00038C10.4093 0.432046 11.6687 0 13 0C14.3313 0 15.5907 0.432046 17.2474 1.00038C17.3347 1.03033 17.4231 1.06066 17.5127 1.09133L16.865 2.98354C14.9495 2.32785 13.9917 2 13 2C12.0083 2 11.0505 2.32785 9.135 2.98354L8.43489 3.22319C4.76017 4.48106 2.92282 5.10999 2.46141 5.76739C2 6.42478 2 8.37886 2 12.287V14.2117C2 21.1026 7.18095 24.4467 10.4316 25.8667C11.3133 26.2519 11.7542 26.4444 13 26.4444C14.2458 26.4444 14.6866 26.2519 15.5684 25.8667C18.819 24.4467 24 21.1026 24 14.2117V12.287C24 8.37886 24 6.42478 23.5386 5.76739C23.0772 5.10999 21.2398 4.48106 17.5651 3.22319L16.865 2.98354L17.5127 1.09133L18.2786 1.35351C20.0603 1.96338 21.481 2.44966 22.5096 2.86753C23.032 3.07975 23.5188 3.30011 23.9317 3.53991C24.316 3.76307 24.8128 4.10144 25.1756 4.61841C25.5327 5.12716 25.6856 5.70138 25.7692 6.13539C25.8592 6.60236 25.9086 7.13406 25.9394 7.69943C26 8.81327 26 10.3225 26 12.2194V14.2117C26 22.3372 19.8349 26.1855 16.369 27.6994C16.3508 27.7074 16.3325 27.7154 16.314 27.7235C15.9143 27.8983 15.452 28.1005 14.9167 28.2375C14.328 28.3882 13.7286 28.4444 13 28.4444C12.2714 28.4444 11.672 28.3882 11.0833 28.2375C10.548 28.1005 10.0858 27.8983 9.686 27.7235C9.66753 27.7154 9.64918 27.7074 9.63097 27.6994C6.16513 26.1855 2.03493e-07 22.3372 2.03493e-07 14.2117V12.2193C-8.37957e-06 10.3225 -1.52886e-05 8.81326 0.0606346 7.69943C0.0914199 7.13406 0.1408 6.60236 0.230789 6.13539ZM13.747 14.7537C13.8538 14.6038 13.9167 14.4203 13.9167 14.2222V9.33333C13.9167 8.82707 13.5063 8.41667 13 8.41667C12.4937 8.41667 12.0833 8.82707 12.0833 9.33333V14.2222C12.0833 14.4203 12.1462 14.6038 12.253 14.7537C12.4192 14.9868 12.6919 15.1389 13 15.1389C13.3081 15.1389 13.5808 14.9868 13.747 14.7537ZM13.8519 17.0125C13.6318 16.7985 13.3313 16.6667 13 16.6667C12.6687 16.6667 12.3682 16.7985 12.1481 17.0125C11.9197 17.2346 11.7778 17.5452 11.7778 17.8889C11.7778 18.5639 12.325 19.1111 13 19.1111C13.675 19.1111 14.2222 18.5639 14.2222 17.8889C14.2222 17.5452 14.0803 17.2346 13.8519 17.0125ZM12.8154 17.1331C12.475 17.216 12.2222 17.5229 12.2222 17.8889C12.2222 18.3184 12.5704 18.6667 13 18.6667C13.4296 18.6667 13.7778 18.3184 13.7778 17.8889C13.7778 17.5229 13.525 17.216 13.1846 17.1331C13.1235 17.137 13.062 17.1389 13 17.1389C12.938 17.1389 12.8765 17.137 12.8154 17.1331Z'
                            fill='white'
                          />
                        </g>
                        <defs>
                          <clipPath id='clip0_128_1768'>
                            <rect width='26' height='29' fill='white' />
                          </clipPath>
                        </defs>
                      </svg>
                    );
                  }}
                />
              </span>
            )}
          </Col>
          <Col>
            <div>
              <span
                style={{
                  fontSize: 18,
                  color: '#000',
                  fontWeight: 500,
                }}
              >
                Hi {props.user ? props.user.name || props.user.id : ''}
              </span>
            </div>
          </Col>
          <Col>
            <div>
              <span style={{ fontSize: 13, color: '#6f6f6f' }}>{props.user ? props.user.id : '--/--'}</span>
            </div>
          </Col>
        </Row>
      </Col>

      <Col xs={24} style={{ marginTop: 20 }}>
        <Row type='flex' style={{ color: '#000', fontSize: 15 }} gutter={[15, 20]} align='middle'>
          <Col xs={24} className='profile-list-menu-dropdow'>
            <Link to={{ pathname: '/companies/select' }}>
              <Row type='flex' gutter={[10, 5]} align='middle' justify='space-between'>
                <Col>
                  <Row type='flex' gutter={[10, 5]} align='middle'>
                    <Col>
                      <Avatar
                        src={props.user ? _.get(props.user, 'orgCtx.organization.imageLink', undefined) : undefined}
                        size={30}
                      />
                    </Col>
                    <Col>
                      <span
                        style={{
                          fontWeight: 500,
                          fontSize: 13,
                        }}
                      >
                        <Tooltip title={_.get(props.user, 'orgCtx.organization.name', '')}>
                          {truncateLongText(_.get(props.user, 'orgCtx.organization.name', ''), 20)}
                        </Tooltip>
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Button size='small' type='default' icon='right'></Button>
                </Col>
              </Row>
            </Link>
          </Col>
          <Col xs={24} className='profile-list-menu-dropdow'>
            <Link to={'/my-account-info'}>
              <Row type='flex' gutter={[10, 5]} align='middle' justify='space-between'>
                <Col>
                  <Row type='flex' gutter={[10, 5]} align='middle'>
                    <Col>
                      <Avatar
                        className='avatar-dropdown'
                        icon={
                          <Icon
                            component={() => {
                              return (
                                <svg
                                  width='1em'
                                  height='1em'
                                  viewBox='0 0 16 21'
                                  fill='currentColor'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <path
                                    d='M11.9666 4.95516C11.9666 7.28057 10.0815 9.16568 7.75612 9.16568C5.43071 9.16568 3.54559 7.28057 3.54559 4.95516C3.54559 2.62975 5.43071 0.744629 7.75612 0.744629C10.0815 0.744629 11.9666 2.62975 11.9666 4.95516Z'
                                    fill='currentColor'
                                  />
                                  <path
                                    d='M15.1245 16.5341C15.1245 18.8595 11.8256 20.7446 7.75612 20.7446C3.68665 20.7446 0.387695 18.8595 0.387695 16.5341C0.387695 14.2087 3.68665 12.3236 7.75612 12.3236C11.8256 12.3236 15.1245 14.2087 15.1245 16.5341Z'
                                    fill='currentColor'
                                  />
                                </svg>
                              );
                            }}
                          />
                        }
                        size={30}
                      />
                    </Col>
                    <Col>
                      <span
                        style={{
                          fontWeight: 500,
                          fontSize: 13,
                        }}
                      >
                        Manage your profile
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Button size='small' type='default' icon='right'></Button>
                </Col>
              </Row>
            </Link>
          </Col>
          <Col xs={24} className='profile-list-menu-dropdow'>
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item>
                    {/* <a href={props.accountUrl + 'logout?url=' + props.appUrl || ''}>Sign out this device</a> */}
                    <a
                      onClick={() => {
                        props.setGlobalLoading(true);

                        props.userLogout().then(() => {
                          props.setGlobalLoading(false);
                          props.history.replace('/login');
                        });
                      }}
                    >
                      Sign out this device
                    </a>
                  </Menu.Item>
                  <Menu.Divider />
                  <Menu.Item>
                    {/* <a href={props.accountUrl + 'logout?signoutall=true&url=' + props.appUrl || ''}>
                      Sign out all devices
                    </a> */}
                    <a
                      onClick={() => {
                        props.setGlobalLoading(true);

                        props.userLogoutAll().then(() => {
                          props.setGlobalLoading(false);
                          props.history.replace('/login');
                        });
                      }}
                    >
                      Sign out all devices
                    </a>
                  </Menu.Item>
                </Menu>
              }
            >
              <Row type='flex' gutter={[10, 5]} align='middle' justify='space-between'>
                <Col>
                  <Row type='flex' gutter={[10, 5]} align='middle'>
                    <Col>
                      <Avatar
                        className='avatar-dropdown'
                        style={{
                          background: 'transparent',
                        }}
                        icon={
                          <Icon
                            component={() => {
                              return (
                                <svg
                                  width='1em'
                                  height='1em'
                                  viewBox='0 0 20 20'
                                  fill='currentColor'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <path
                                    fill-rule='evenodd'
                                    clip-rule='evenodd'
                                    d='M13.2319 10.2446C13.2319 9.8454 12.9083 9.52174 12.509 9.52174L2.93294 9.52174L4.82275 7.90191C5.12588 7.64208 5.16098 7.18572 4.90116 6.88259C4.64133 6.57946 4.18496 6.54435 3.88183 6.80418L0.508302 9.69578C0.348074 9.83311 0.255859 10.0336 0.255859 10.2446C0.255859 10.4557 0.348074 10.6562 0.508302 10.7935L3.88183 13.6851C4.18496 13.9449 4.64133 13.9098 4.90116 13.6067C5.16098 13.3036 5.12588 12.8472 4.82275 12.5874L2.93294 10.9675L12.509 10.9675C12.9083 10.9675 13.2319 10.6439 13.2319 10.2446Z'
                                    fill='currentColor'
                                  />
                                  <path
                                    d='M6.72582 6.38918C6.72582 7.066 6.72582 7.40441 6.88824 7.64751C6.95857 7.75277 7.04895 7.84315 7.15422 7.91348C7.39732 8.0759 7.73573 8.0759 8.41254 8.0759L12.509 8.0759C13.7068 8.0759 14.6777 9.04686 14.6777 10.2446C14.6777 11.4423 13.7068 12.4133 12.509 12.4133L8.41262 12.4133C7.73573 12.4133 7.39728 12.4133 7.15416 12.5758C7.04894 12.6461 6.95859 12.7364 6.88828 12.8416C6.72582 13.0848 6.72582 13.4232 6.72582 14.1001C6.72582 16.8263 6.72582 18.1894 7.57275 19.0364C8.41968 19.8833 9.78258 19.8833 12.5088 19.8833L13.4727 19.8833C16.1989 19.8833 17.562 19.8833 18.4089 19.0364C19.2559 18.1894 19.2559 16.8263 19.2559 14.1001L19.2559 6.38918C19.2559 3.66296 19.2559 2.29984 18.4089 1.45291C17.562 0.605981 16.1989 0.605983 13.4727 0.605983L12.5088 0.605983C9.78258 0.605983 8.41967 0.605981 7.57275 1.45291C6.72582 2.29984 6.72582 3.66295 6.72582 6.38918Z'
                                    fill='currentColor'
                                  />
                                </svg>
                              );
                            }}
                          />
                        }
                        size={30}
                      />
                    </Col>
                    <Col>
                      <span
                        style={{
                          fontWeight: 500,
                          fontSize: 13,
                        }}
                      >
                        Sign out
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Button size='small' type='default' icon='right'></Button>
                </Col>
              </Row>
            </Dropdown>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default AccountDropDown;
